module.exports = __webpack_public_path__ + "assets/img/icon8-menu2.bbd7ce63.svg";